<template>
  <div></div>
</template>

<script>
export default {
  data: function () {
    return {};
  },

  created: function () {
    this.$router.push("/booking");
  },
};
</script>

<style scoped>
</style>
